import * as yup from 'yup'

import { makeNumberSchema } from '@/componentsV1/BaseComponents'
import { TaxListQuestionId } from '../../service'

export const homeOfficeSquareFootageQuestionIds = [
  TaxListQuestionId.home_office_sq_ft_for_business,
  TaxListQuestionId.home_office_sq_ft_total,
]

export const homeOfficeSquareFootageSchema = yup.object({
  squareFtUsedForBusiness: makeNumberSchema({ field: 'square footage' }),
  totalSquareFtOfHome: makeNumberSchema({ field: 'square footage' }).test(
    'testSizes',
    "Office square footage can't be more than total square footage",
    function compareSizes(totalSquareFtOfHome) {
      const { squareFtUsedForBusiness } = this.parent
      if (!totalSquareFtOfHome || !squareFtUsedForBusiness) {
        return true
      }
      return Number(totalSquareFtOfHome) >= Number(squareFtUsedForBusiness)
    }
  ),
})
